import { Sort } from '@angular/material/sort';
import { Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { compareByNestedKey, compareNumbers, compareSeparatorLongStringNumbers, compareStrings } from '@shared/utils';
import {
  InputTableFilter,
  RadioTableFilter,
  TableFilterConfig,
  TableFilterType,
} from '@shared/components/table-filter-menu';
import { ProductBalanceStatus } from '@components/dashboard/fulfillment/fulfillment.enums';

export const PRODUCT_BALANCES_ITEMS_PER_PAGE = 5;

export const PRODUCT_BALANCES_DISPLAYED_COLUMNS = [
  'warehouse',
  'article',
  'goods',
  'status',
  'batch',
  'amount',
  'amountReserve',
  'amountAvailable',
];

export const PRODUCT_BALANCES_DISABLE_COLUMNS = [
  { name: 'warehouse', disable: true },
  { name: 'article', disable: true },
  { name: 'goods', disable: true },
  { name: 'status', disable: true },
  { name: 'batch', disable: true },
  { name: 'amount', disable: true },
  { name: 'amountReserve', disable: true },
  { name: 'amountAvailable', disable: true },
];

export const PRODUCT_BALANCES_COLUMNS_CONFIG = [
  {
    name: 'Назва номенклатури',
    show: true,
    class: 'goods',
  },
  {
    name: 'Статус номенклатури',
    show: true,
    class: 'status',
  },
  {
    name: 'Партія номенклатури',
    show: true,
    class: 'batch',
  },
  {
    name: 'Загальна кількість',
    show: true,
    class: 'amount',
  },
  {
    name: 'Зарезервована кількість',
    show: true,
    class: 'amountReserve',
  },
  {
    name: 'Доступна кількість',
    show: true,
    class: 'amountAvailable',
  },
];

export const PRODUCT_BALANCES_DEFAULT_SORT_EVENT: Sort = {
  active: 'amountAvailable',
  direction: 'desc',
};

export const PRODUCT_BALANCES_SORT_CONFIG = {
  warehouse: compareByNestedKey(compareSeparatorLongStringNumbers, 'warehouse'),
  article: compareByNestedKey(compareSeparatorLongStringNumbers, 'article'),
  goods: compareByNestedKey(compareStrings, 'goods'),
  status: compareByNestedKey(compareNumbers, 'status'),
  batch: compareByNestedKey(compareNumbers, 'batch'),
  amount: compareByNestedKey(compareNumbers, 'amount'),
  amountReserve: compareByNestedKey(compareNumbers, 'amountReserve'),
  amountAvailable: compareByNestedKey(compareNumbers, 'amountAvailable'),
};

export const PRODUCT_BALANCES_ARTICLE_FILTER: InputTableFilter = {
  title: 'Артикул',
  controlName: 'article',
  type: TableFilterType.Input,
  testId: 'inputFilter',
  initialValue: '',
  apiFieldName: 'ArticleList',
  validators: [Validators.minLength(1), Validators.maxLength(40)],
  errors: {
    maxlength: 'Максимальна довжина 40 символів',
    minlength: 'Введіть, будь ласка, повний артикул',
  },
  placeholder: 'Введіть артикул',
  hotFilter: {
    type: TableFilterType.Input,
    quickButtonText: 'Артикул',
    overlayTitle: 'Артикул',
    overlayButtonText: 'Знайти у залишках',
    order: 1,
  },
  applyTrim: true,
  chipData: {
    content: (value) => `Артикул: ${value}`,
  },
};

export const PRODUCT_BALANCES_STATUS_FILTER: RadioTableFilter = {
  title: 'Статус номенклатури',
  type: TableFilterType.Radio,
  testId: 'product-balances-status-filter',
  errors: {},
  placeholder: '',
  controlName: 'status',
  initialValue: 'Всі',
  apiFieldName: 'StatusList',
  validators: [],
  options: [
    { value: 'Всі', label: 'Всі', testId: 'Всі' },
    {
      value: ProductBalanceStatus.Condition,
      label: ProductBalanceStatus.Condition,
      testId: ProductBalanceStatus.Condition,
    },
    { value: ProductBalanceStatus.Lost, label: ProductBalanceStatus.Lost, testId: ProductBalanceStatus.Lost },
    { value: ProductBalanceStatus.Defect, label: ProductBalanceStatus.Defect, testId: ProductBalanceStatus.Defect },
    {
      value: ProductBalanceStatus.ReceivingDefect,
      label: ProductBalanceStatus.ReceivingDefect,
      testId: ProductBalanceStatus.ReceivingDefect,
    },
    {
      value: ProductBalanceStatus.WarehouseDefect,
      label: ProductBalanceStatus.WarehouseDefect,
      testId: ProductBalanceStatus.WarehouseDefect,
    },
    { value: ProductBalanceStatus.Broken, label: ProductBalanceStatus.Broken, testId: ProductBalanceStatus.Broken },
    {
      value: ProductBalanceStatus.Repackaging,
      label: ProductBalanceStatus.Repackaging,
      testId: ProductBalanceStatus.Repackaging,
    },
    { value: ProductBalanceStatus.Expired, label: ProductBalanceStatus.Expired, testId: ProductBalanceStatus.Expired },
    {
      value: ProductBalanceStatus.Disposal,
      label: ProductBalanceStatus.Disposal,
      testId: ProductBalanceStatus.Disposal,
    },
  ],
  hotFilter: {
    type: TableFilterType.Radio,
    quickButtonText: 'Статус номенклатури',
    overlayTitle: 'Статус номенклатури',
    overlayButtonText: 'Застосувати',
    order: 2,
  },
  chipData: {
    content: (value) => value,
  },
};

export const PRODUCT_BALANCES_FILTER_CONFIG: TableFilterConfig = {
  title: 'Фільтри',
  storageKey: 'product-balances-filters',
  buttons: {
    clearFilters: {
      text: 'Очистити все',
      testId: 'clearFiltersBtn',
      autofocus: false,
      class: 'btn',
    },
    applyFilters: {
      text: 'Застосувати фільтри',
      testId: 'applyFiltersBtn',
      color: 'primary' as ThemePalette,
    },
  },
  filterGroups: [
    {
      title: 'Дані про залишки',
      testId: 'group1',
      controlName: 'group1',
      expandedByDefault: true,
      filters: [PRODUCT_BALANCES_ARTICLE_FILTER, PRODUCT_BALANCES_STATUS_FILTER],
    },
  ],
};
